"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var list_1 = __importDefault(require("../../list"));
var detail_1 = __importDefault(require("../../detail"));
var add_1 = __importDefault(require("../../add"));
var data_def_1 = require("../../data-def");
function App(props) {
    var _a, _b;
    var FormUI = props.FormUI, ViewUI = props.ViewUI, dataDef = props.dataDef, CustomListContainer = props.CustomListContainer, CustomListItem = props.CustomListItem, noDataMessages = props.noDataMessages, NoDataComponents = props.NoDataComponents;
    var urlPrefix = dataDef.urlPrefix, detailUrlPrefix = dataDef.detailUrlPrefix, addRedirect = dataDef.addRedirect;
    var routes = data_def_1.routesFromPrefix(detailUrlPrefix);
    var linkBack = urlPrefix;
    var Data = props.Data;
    var extra = props.extra;
    var toRoute = function (r) {
        if (r === void 0) { r = '/'; }
        return urlPrefix + r;
    };
    return (react_1["default"].createElement(react_router_dom_1.Switch, null,
        ((_a = dataDef.displayType) === null || _a === void 0 ? void 0 : _a.add) !== false && (react_1["default"].createElement(react_router_dom_1.Route, { exact: true, path: toRoute(routes.add), component: function (props) {
                var _a, _b;
                return (react_1["default"].createElement(add_1["default"], __assign({ UI: FormUI, insertPromise: Data.insert, linkBack: linkBack, onUpdate: addRedirect, message: (_a = dataDef.customMessages) === null || _a === void 0 ? void 0 : _a.add, withPaper: (_b = dataDef.paper) === null || _b === void 0 ? void 0 : _b.add, PaperComponent: dataDef.PaperComponent }, props)));
            } })),
        ((_b = dataDef.displayType) === null || _b === void 0 ? void 0 : _b.detail) !== false && (react_1["default"].createElement(react_router_dom_1.Route, { path: toRoute(routes.detail) },
            react_1["default"].createElement(detail_1["default"], { config: dataDef, ViewUI: ViewUI, FormUI: FormUI, Data: Data, extra: extra, noDataMessage: noDataMessages === null || noDataMessages === void 0 ? void 0 : noDataMessages.detail, NoDataComponent: NoDataComponents === null || NoDataComponents === void 0 ? void 0 : NoDataComponents.detail }))),
        react_1["default"].createElement(react_router_dom_1.Route, { path: toRoute('/') }, Data.asyncData !== undefined ? (react_1["default"].createElement(list_1["default"], { asyncData: Data.asyncData, dataDef: dataDef, addUrl: toRoute(routes.add), onDelete: Data.deleteById, CustomListContainer: CustomListContainer, CustomListItem: CustomListItem })) : (react_1["default"].createElement(list_1["default"], { dataDef: dataDef, dataLoad: Data.list, addUrl: toRoute(routes.add), onDelete: Data.deleteById, CustomListContainer: CustomListContainer, CustomListItem: CustomListItem, noDataMessage: noDataMessages === null || noDataMessages === void 0 ? void 0 : noDataMessages.list, NoDataComponent: NoDataComponents === null || NoDataComponents === void 0 ? void 0 : NoDataComponents.list })))));
}
exports["default"] = App;
